module.exports = __webpack_public_path__ + "static/media/shijialuo.544d452f.jpg";